<div class="s-overlay" *ngIf="visible" (click)="goToLogin()">
  <div class="s-modal" (click)="$event.stopPropagation()">

    <!-- Gold top bar (matches your OTP modal) -->
    <div class="s-bar"></div>

    <div class="s-body">

      <!-- Icon -->
      <div class="s-icon-wrap">

        <!-- Device icon for SESSION_REPLACED -->
        <svg *ngIf="isReplaced"
          xmlns="http://www.w3.org/2000/svg" width="28" height="28"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>

        <!-- Clock icon for SESSION_INACTIVE -->
        <svg *ngIf="isInactive"
          xmlns="http://www.w3.org/2000/svg" width="28" height="28"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12 6 12 12 16 14"/>
        </svg>

      </div>

      <!-- Eyebrow -->
      <div class="s-eyebrow">Session Ended</div>

      <!-- Heading -->
      <h3 class="s-heading">
        {{ isReplaced ? 'Signed in elsewhere' : 'You were away too long' }}
      </h3>

      <!-- What happened -->
      <p class="s-message">{{ data?.message }}</p>

      <!-- What happened breakdown -->
      <div class="s-info-box">
        <div class="s-info-row" *ngIf="isReplaced">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
            viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span>Only one active session is allowed at a time for your security.</span>
        </div>
        <div class="s-info-row" *ngIf="isInactive">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
            viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span>Sessions expire after 3 hours of inactivity to keep your account safe.</span>
        </div>
      </div>

      <!-- CTA -->
      <button class="s-btn" type="button" (click)="goToLogin()">
        Log Back In
      </button>

      <!-- Footer note -->
      <p class="s-note">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        <span *ngIf="isReplaced">If this wasn't you, log back in and change your password immediately.</span>
        <span *ngIf="isInactive">Your progress is saved. Log back in to pick up where you left off.</span>
      </p>

    </div>
  </div>
</div>